/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { headerBusinessModelDtoSchema } from "./headerBusinessModelDtoSchema.ts";
import { headerCompanyStageDtoSchema } from "./headerCompanyStageDtoSchema.ts";
import { headerGeographyDtoSchema } from "./headerGeographyDtoSchema.ts";
import { headerIndustryDtoSchema } from "./headerIndustryDtoSchema.ts";
import { headerOwnershipDtoSchema } from "./headerOwnershipDtoSchema.ts";
import { headerProductStageDtoSchema } from "./headerProductStageDtoSchema.ts";
import { headerTeamSizeDtoSchema } from "./headerTeamSizeDtoSchema.ts";
import { headerTrlDtoSchema } from "./headerTrlDtoSchema.ts";
import { z } from "zod/v4";

export const headerDtoSchema = z.object({
  get teamSize() {
    return headerTeamSizeDtoSchema.optional();
  },
  get geography() {
    return headerGeographyDtoSchema.optional();
  },
  get trl() {
    return headerTrlDtoSchema.optional();
  },
  get productStage() {
    return headerProductStageDtoSchema.optional();
  },
  get businessModel() {
    return headerBusinessModelDtoSchema.optional();
  },
  get industry() {
    return headerIndustryDtoSchema.optional();
  },
  get ownership() {
    return headerOwnershipDtoSchema.optional();
  },
  get companyStage() {
    return headerCompanyStageDtoSchema.optional();
  },
});
